module.exports = __webpack_public_path__ + "static/media/3 Hang Me, Oh Hang Me.7ffc534e.mp3";